module.exports = __webpack_public_path__ + "img/yan_an_road.de37872e.png";